import { render, staticRenderFns } from "./MyGridBootstrapTable.vue?vue&type=template&id=07452b73&scoped=true&"
import script from "./MyGridBootstrapTable.vue?vue&type=script&lang=js&"
export * from "./MyGridBootstrapTable.vue?vue&type=script&lang=js&"
import style0 from "./MyGridBootstrapTable.vue?vue&type=style&index=0&id=07452b73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07452b73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07452b73')) {
      api.createRecord('07452b73', component.options)
    } else {
      api.reload('07452b73', component.options)
    }
    module.hot.accept("./MyGridBootstrapTable.vue?vue&type=template&id=07452b73&scoped=true&", function () {
      api.rerender('07452b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyGridBootstrapTable.vue"
export default component.exports